import api from "./api";

// Capa de servicios API del simulador de flujos (0383 FS-2.1).
// Wrappers de transporte finos: el payload lo construye el hook, aquí solo vive el endpoint.
// Prefijo /flow-simulator — NO /sim, que ya lo usa el remarketing individual programado.

export const startSimulation = (payload) =>
  api.post("/flow-simulator/sessions", payload);

export const replySimulation = (sessionId, payload) =>
  api.post(`/flow-simulator/sessions/${sessionId}/reply`, payload);

export const restartSimulation = (sessionId, payload) =>
  api.post(`/flow-simulator/sessions/${sessionId}/restart`, payload);

// Cerrar la sesión libera el ticket sandbox. Si el navegador se cierra en seco y este DELETE
// nunca sale, el cron de purga del backend (cada 15 min) se lleva el sandbox igualmente: no se
// añade aquí un sendBeacon porque exigiría un endpoint sin JWT solo para eso.
export const stopSimulation = (sessionId) =>
  api.delete(`/flow-simulator/sessions/${sessionId}`);
